export default __webpack_public_path__ + "static/media/uploader-medtronic-problem-2.5ccb6fcc.png";